const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m22.92 12-2.75-2.78a1 1 0 0 0-1.39 0l-3.36 3.1a.26.26 0 0 1-.27 0 .25.25 0 0 1-.15-.22v-11a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a.25.25 0 0 1-.15.23.27.27 0 0 1-.27 0L5.22 9.19a1 1 0 0 0-1.39 0L1.08 12a1 1 0 0 0 0 1.42l10.21 10.19a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l10.21-10.22a1 1 0 0 0 0-1.39Z" fill="currentColor"></path></svg>';
export {
  a as default
};
